import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUpload,
  FaTags,
  FaPlusSquare,
  FaBars,
  FaTimes,
  FaLink,
  FaBlog,
  FaEdit,
  FaEnvelope,
  FaFileAlt,
  FaRegEdit, FaLayerGroup } from "react-icons/fa";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { name: "Dashboard", path: "/", icon: <FaTachometerAlt /> },
    { name: "Upload", path: "/upload", icon: <FaUpload /> },
    { name: "Create Store", path: "/create-store", icon: <FaPlusSquare /> },
    { name: "Coupons", path: "/coupons", icon: <FaTags /> },
    { name: "Categories", path: "/categories", icon: <FaLayerGroup /> },
    { name: "Subscribers", path: "/subscribers", icon: <FaEnvelope /> },
    { name: "Logo & Links", path: "/stores", icon: <FaLink /> },
    { name: "Create Blog", path: "/create-blog", icon: <FaBlog /> },
    { name: "Edit Blog", path: "/edit-blog", icon: <FaEdit /> },
    { name: "Create Page", path: "/create-page", icon: <FaFileAlt /> },
    { name: "Edit Pages", path: "/edit-page", icon: <FaRegEdit /> },
    { name: "Tracking", path: "/track", icon: <FaTachometerAlt />, isExternal: true },
  ];

  return (
    <>
      {/* Mobile Menu Button - Visible only on mobile */}
      <div className="md:hidden fixed top-4 left-4 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-gray-800 focus:outline-none bg-white p-2 rounded shadow-md"
        >
          {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>

      {/* Overlay - Visible only when sidebar is open on mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}

      {/* Sidebar - Fixed on mobile, Relative on desktop */}
      <aside
        className={`
          flex flex-col w-64 bg-gray-800 text-white h-screen 
          fixed md:relative top-0 left-0 z-40
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"} 
          md:translate-x-0
        `}
      >
        <div className="p-6 text-center border-b border-gray-700">
          <h2 className="text-2xl font-bold">Savings Atlas</h2>
        </div>

        <nav className="mt-4 flex-1 overflow-y-auto">
          <ul>
            {menuItems.map((item) => (
              <li key={item.name} className="flex items-center mb-1">
                {item.isExternal ? (
                  <a
                    href={item.path}
                    onClick={() => setIsOpen(false)}
                    className="w-full flex items-center py-3 px-6 hover:bg-gray-700 transition-colors duration-200"
                  >
                    <span className="mr-3 text-lg">{item.icon}</span>
                    <span className="text-base font-medium">{item.name}</span>
                  </a>
                ) : (
                  <Link
                    to={item.path}
                    onClick={() => setIsOpen(false)} // Close menu on mobile when clicked
                    className="w-full flex items-center py-3 px-6 hover:bg-gray-700 transition-colors duration-200"
                  >
                    <span className="mr-3 text-lg">{item.icon}</span>
                    <span className="text-base font-medium">{item.name}</span>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
